export const queryKeys = {
  me: ['admin', 'me'],
  overview: ['assessment', 'overview'],
  patterns: ['assessment', 'patterns'],
  pattern: (id) => ['assessment', 'patterns', String(id)],
  weightMatrix: (id, sectionId) => ['assessment', 'weight-matrix', String(id), sectionId == null ? 'all' : String(sectionId)],
  sections: ['assessment', 'sections'],
  section: (id) => ['assessment', 'sections', String(id)],
  questions: (sectionId) => ['assessment', 'questions', sectionId == null ? 'all' : String(sectionId)],
  question: (id) => ['assessment', 'questions', 'detail', String(id)],
  answer: (id) => ['assessment', 'answers', String(id)],
  versions: ['assessment', 'versions'],
  version: (id) => ['assessment', 'versions', String(id)],
  topThreeProfiles: (filters) => ['assessment', 'top-three-profiles', filters],
  topThreeProfile: (id, versionId) => ['assessment', 'top-three-profiles', 'detail', String(versionId || ''), String(id)],
  topThreeProfileCoverage: (versionId) => ['assessment', 'top-three-profiles', 'coverage', String(versionId)],
  tags: ['assessment', 'tags'],
  tag: (id) => ['assessment', 'tags', String(id)],
  personalSummaries: (filters) => ['assessment', 'personal-summaries', filters],
  personalSummary: (id) => ['assessment', 'personal-summaries', 'detail', String(id)],
  resultItems: (filters) => ['assessment', 'result-items', filters],
  resultItemCatalog: ['assessment', 'result-items', 'catalog'],
  resultItem: (id) => ['assessment', 'result-items', 'detail', String(id)],
  attempts: (filters) => ['assessment', 'attempts', filters],
  attempt: (id) => ['assessment', 'attempts', 'detail', String(id)],
  specialists: (filters = null) => (
    filters && Object.keys(filters).length > 0
      ? ['operations', 'specialists', filters]
      : ['operations', 'specialists']
  ),
  specialist: (id) => ['operations', 'specialists', String(id)],
  consultations: (filters) => ['operations', 'consultations', filters],
  consultation: (id) => ['operations', 'consultations', 'detail', String(id)],
  consultationHistory: (id) => ['operations', 'consultations', 'history', String(id)],
  supportCategories: ['operations', 'support-categories'],
  supportTickets: (filters) => ['operations', 'support-tickets', filters],
  supportTicket: (id) => ['operations', 'support-tickets', 'detail', String(id)],
  legalDocuments: (filters) => ['operations', 'legal-documents', filters],
  legalDocument: (id) => ['operations', 'legal-documents', 'detail', String(id)],
  companyPlans: (filters) => ['company-plans', 'plans', filters],
  companyPlan: (id) => ['company-plans', 'plans', 'detail', String(id)],
  companies: (filters) => ['company-plans', 'companies', filters],
  company: (id) => ['company-plans', 'companies', 'detail', String(id)],
  planPurchases: (filters) => ['company-plans', 'purchases', filters],
  planPurchase: (id) => ['company-plans', 'purchases', 'detail', String(id)],
  companyEntitlements: (filters) => ['company-plans', 'entitlements', filters],
  companyEntitlement: (id) => ['company-plans', 'entitlements', 'detail', String(id)],
  accessCodeBatches: (filters) => ['company-plans', 'code-batches', filters],
  accessCodeBatch: (id) => ['company-plans', 'code-batches', 'detail', String(id)],
  accessCodes: (filters) => ['company-plans', 'access-codes', filters],
  accessCode: (id) => ['company-plans', 'access-codes', 'detail', String(id)],
  sponsoredAssessments: (filters) => ['company-plans', 'sponsored-assessments', filters],
  sponsoredAssessment: (id) => ['company-plans', 'sponsored-assessments', 'detail', String(id)],
  workbooks: {
    questionnaireImport: ['assessment', 'workbooks', 'questionnaire', 'import'],
    newQuestionsTemplate: ['assessment', 'workbooks', 'new-questions', 'template'],
    newQuestionsPreview: ['assessment', 'workbooks', 'new-questions', 'preview'],
    newQuestionsCommit: ['assessment', 'workbooks', 'new-questions', 'commit'],
  },
};
